import { createContext } from 'react'

interface InfiniteScrollContextType {
    loadMore: () => void
    hasMore: boolean
    isLoading: boolean
    reset?: () => void
}

export const InfiniteScrollContext =
    createContext<InfiniteScrollContextType | null>(null)
